import VueCalculator from '@views/calculator/index';

export default [
  {
    path: '/calculator',
    name: 'calculator#index',
    component: VueCalculator,
  },
];
